export default function AboutSection() {
  const locations = [
    {
      image: "/images/sucursal1.jpg",
      title: "Sucursal Principal",
      subtitle: "Centro Cambiario de Confianza",
      location: "Mexicali Centro",
      description: [
        "Del Sol Centro Cambiario se encuentra ubicado en el corazón de Mexicali, Baja California. Somos especialistas en cambio de divisas y transferencias internacionales, respaldados por profesionales con décadas de experiencia en el sector financiero.",
        "Nuestra sucursal principal está estratégicamente ubicada en Cuauhtémoc Norte 21200, Justo Sierra 211-A, ofreciendo un servicio accesible y confiable para toda la comunidad.",
        "Te ofrecemos las mejores tasas de cambio del mercado con la seguridad y transparencia que nos caracteriza. Nuestro horario de atención es de lunes a sábado, de 7:00 a.m. a 7:00 p.m. ¡Visítanos y comprueba la diferencia!"
      ]
    },
    {
      image: "/images/sucursal2.jpg",
      title: "Segunda Sucursal",
      subtitle: "Servicio de Excelencia",
      location: "Mexicali Norte",
      description: [
        "Nuestra segunda ubicación te brinda la misma calidad y confianza que nos caracteriza. Ubicada en Calz. Justo Sierra 18, Nueva, 21100 Mexicali, B.C., esta sucursal está estratégicamente situada para servir mejor a nuestros clientes del área norte de la ciudad.",
        "Con el mismo compromiso de ofrecer las mejores tasas de cambio y un servicio personalizado, esta sucursal cuenta con instalaciones modernas y un equipo altamente capacitado.",
        "Abrimos de lunes a sábado de 7:00 a.m. a 11:00 p.m., y los domingos de 7:00 a.m. a 7:00 p.m., con horarios extendidos y atención dedicada para que tu experiencia de cambio de divisas sea rápida, segura y satisfactoria."
      ]
    }
  ]

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-16 text-center" style={{ color: 'var(--brand-red)' }}>
          Nuestras Ubicaciones
        </h2>
        
        <div className="space-y-24 max-w-7xl mx-auto">
          {locations.map((location, index) => (
            <div 
              key={index}
              className={`flex flex-col md:flex-row items-center gap-12 ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* Imagen */}
              <div className="flex-1">
                <img 
                  src={location.image}
                  alt={location.title}
                  className="rounded-lg shadow-xl w-full h-auto object-cover"
                  style={{ maxHeight: '400px' }}
                />
              </div>

              {/* Contenido */}
              <div className="flex-1">
                <div className="mb-2 text-sm font-semibold" style={{ color: 'var(--brand-gold)' }}>
                  {location.location}
                </div>
                <h3 className="text-3xl font-bold mb-2" style={{ color: 'var(--brand-red)' }}>
                  {location.title}
                </h3>
                <h4 className="text-xl font-semibold mb-6" style={{ color: 'var(--text)', opacity: 0.7 }}>
                  {location.subtitle}
                </h4>
                
                {location.description.map((paragraph, i) => (
                  <p key={i} className="mb-4 leading-relaxed" style={{ color: 'var(--text)' }}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}